import { Alert, Snackbar } from '@mui/material';
import {
  closeSnackbar,
  useSnackbarStore,
} from '../../../../store/components/snackbarStore';

export function SnackbarRenderer() {
  const { message, open, type } = useSnackbarStore();

  return (
    <Snackbar
      open={open}
      autoHideDuration={3000}
      onClose={closeSnackbar}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert severity={type} variant="filled" onClose={closeSnackbar}>
        {message}
      </Alert>
    </Snackbar>
  );
}
